import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Fichas en papel desorganizadas',
  good: 'Historias clínicas digitales estandarizadas'
}, {
  bad: 'Horas perdidas armando informes',
  good: 'Informes listos para completar en minutos'
}, {
  bad: 'Rechazos de obras sociales',
  good: 'Documentación impecable que agiliza cobros'
}, {
  bad: 'Seguimiento subjetivo o mental',
  good: 'Evolución objetiva y medible por sesión'
}, {
  bad: 'Riesgo legal por falta de registro',
  good: 'Respaldo total con consentimientos firmados'
}, {
  bad: 'Imagen de consultorio improvisado',
  good: 'Percepción de máxima profesionalidad'
}];
export function ComparisonTable() {
  return <section className="py-14 md:py-24 bg-white" data-id="element-77">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78">
        <div className="text-center mb-10 md:mb-16" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-80">
            Tu consultorio hoy vs. tu consultorio con el Megapack
          </h2>
          <div className="w-24 h-1 bg-brand-accent mx-auto rounded-full" data-id="element-81"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden" data-id="element-82">
          <div className="grid grid-cols-2 bg-slate-50 border-b border-slate-200" data-id="element-83">
            <div className="p-6 text-center border-r border-slate-200" data-id="element-84">
              <h3 className="text-lg md:text-xl font-bold text-slate-500" data-id="element-85">
                Sin el Megapack
              </h3>
            </div>
            <div className="p-6 text-center bg-brand-dark" data-id="element-86">
              <h3 className="text-lg md:text-xl font-bold text-brand-accent" data-id="element-87">
                Con el Megapack
              </h3>
            </div>
          </div>

          <div className="divide-y divide-slate-100" data-id="element-88">
            {comparisons.map((row, index) => <motion.div key={index} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="grid grid-cols-2" data-id="element-89">
                <div className="p-4 md:p-6 border-r border-slate-100 flex items-center gap-3 md:gap-4 bg-red-50/30" data-id="element-90">
                  <div className="bg-red-100 p-1.5 rounded-full flex-shrink-0" data-id="element-91">
                    <XIcon className="w-4 h-4 md:w-5 md:h-5 text-red-500" data-id="element-92" />
                  </div>
                  <p className="text-sm md:text-base text-slate-600 font-medium" data-id="element-93">
                    {row.bad}
                  </p>
                </div>
                <div className="p-4 md:p-6 flex items-center gap-3 md:gap-4 bg-emerald-50/30" data-id="element-94">
                  <div className="bg-emerald-100 p-1.5 rounded-full flex-shrink-0" data-id="element-95">
                    <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-emerald-600" data-id="element-96" />
                  </div>
                  <p className="text-sm md:text-base text-slate-900 font-bold" data-id="element-97">
                    {row.good}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}